import React from "react";
import Header from "../Landingpagecomponents/Header/header"
import { Grid, Typography, Paper } from "@material-ui/core";
import Footer from "../Landingpagecomponents/Footer/Footer"

const About = () => {
    return (
    <Grid container xs={12} style={{backgroundColor: "#eaeaea"}}>
        <Header/>
        <Grid xs={12} style={{backgroundColor: "#002D55", height: 250}} />
        <Grid container justify="center" style={{backgroundColor: "#eaeaea", marginTop: 20}}>
            <Paper item xs={12} style={{width: "70%", justify: "center", margin: 20, padding: 20}}>
                <Typography style={{color: "#002D55"}}>
                    <h1>About Virtus Physio</h1>
                    <h2 style={{color: "#002D55"}}>Virtual Physiotherapy supported by A.I. technology</h2>
                    <p>
                    We are an ambitious start-up that is headquartered in Copenhagen, Denmark. <br/><br/>A country that is consistently ranked as having one of the best healthcare systems in the world. 
                    Health is a very important issue for us to address in today's society and we aim to tackle this issue head-on by consistently offer high-quality healthcare service on a virtual platform.
                    At Virtus, we understand the need for change & innovation in healthcare and we are therefore proud to announce our first Virtual Physiotherapist supported by A.I. technology to offer you a better, convenient and affordable healthcare.
                    We believe that by offering our service virtually that patients will experience a higher degree of self-empowerment and control of their individual health challenges.
                    Virtus is Latin for the English word 'virtue', which can translate into: "of high standards", and is at the same time referring to the word 'virtual' and the digitalization of healthcare.
                    By such references, we want to offer high-quality virtual physiotherapy services with virtue on a virtual platform.
                    We want to offer convenient, time-saving, affordable, accessible and cost-effective services & solutions based on the latest research for best-practice virtual physiotherapy.
                    All to the benefit of our clients & patients!
                    All we ask is that you are up for taking actions into your own hands, then we will gladly help you start your journey!
                    </p>
                    <h1>Team</h1>
                    <p>
                    Physiotherapists, Medical advisors, IT consultants
                    </p>
                    <h1>Partners</h1>
                </Typography>
            </Paper>
        </Grid>
        <Grid xs={12} container justify="center" justifyContent="center">
                  <Footer />
        </Grid>
    </Grid>
    );
};

export default About;